import Vue from 'vue'
import Router from 'vue-router'
//其他
import other from './other'

Vue.use(Router)

export default new Router({
  routes: [
    /*{path: '/', meta: {title: '登录'},component: resolve => { require(['@/pages/QrcodeLogin.vue'], resolve) }},*/
    {path: '/', meta: {title: '登录'},component: resolve => { require(['@/pages/XxjsLogin.vue'], resolve) }},
    {path: '/login', meta: {title: '登录'},component: resolve => { require(['@/pages/Login.vue'], resolve) }},
    {path: '/waiting', meta: {title: '钉钉数据拉取等待页面'},component: resolve => { require(['@/pages/Waiting.vue'], resolve) }},
    {path: '/main', meta: {title: '跳转页面'},component: resolve => { require(['@/pages/Main.vue'], resolve) }},
    /*{path: '/systemLogin', meta: {title: '后台监控登录'},component: resolve => { require(['@/pages/SystemLogin.vue'], resolve) }},*/
    {path: '/ssoLogin', meta: {title: '统一认证登录'},component: resolve => { require(['@/pages/SsoLogin.vue'], resolve) }},
    /*{path: '/qrcodeMain', meta: {title: '扫码主页'},component: resolve => { require(['@/pages/QrcodeMain.vue'], resolve) }},*/
    {path: '/index', meta: {title: '前台社团管理'},component: resolve => { require(['@/pages/Index.vue'], resolve) },
      children: [
        {path: 'menuTab',meta: {title: '管理端'}, component: resolve => { require(['../components/stgl/MenuTab.vue'], resolve) },
          children:[
            {path: 'stglList', meta: {title: '社团管理'},component: resolve => { require(['../components/stgl/StglList.vue'], resolve) }},
            {path: 'stzxList', meta: {title: '社团招新'},component: resolve => { require(['../components/stgl/StzxList.vue'], resolve) }},
            {path: 'sthdList', meta: {title: '社团活动'},component: resolve => { require(['../components/stgl/SthdList.vue'], resolve) }},
            {path: 'sthdDetail', meta: {title: '社团活动详情'},component: resolve => { require(['../components/stgl/SthdDetail.vue'], resolve) }},
            {path: 'stpjList', meta: {title: '社团评价'},component: resolve => { require(['../components/stgl/StpjList.vue'], resolve) }},
            {path: 'stkqList', meta: {title: '社团活动考勤'},component: resolve => { require(['../components/stgl/StkqList.vue'], resolve) }},
            {path: 'glySetting', meta: {title: '设置管理员'},component: resolve => { require(['../components/system/GlySetting.vue'], resolve) }},
            {path: 'paramSetTab', meta: {title: '参数设置'}, component: resolve => { require(['../components/paramset/ParamSetTab.vue'], resolve) },
              children: [
                {path: 'paramManager', meta: {title: '参数管理'}, component: resolve => { require(['../components/paramset/ParamManager.vue'], resolve) }},
                {path: 'xxYear', meta: {title: '学年管理'}, component: resolve => { require(['../components/paramset/XxYear.vue'], resolve) }},
                {path: 'xxXnxq', meta: {title: '学期管理'}, component: resolve => { require(['../components/paramset/XxXnxq.vue'], resolve) }},
                {path: 'jxtxl', meta: {title: '家校通讯录'}, component: resolve => { require(['../components/paramset/Jxtxl.vue'], resolve) }},
                {path: 'nbtxl', meta: {title: '内部通讯录'}, component: resolve => { require(['../components/paramset/Nbtxl.vue'], resolve) }},
                {path: 'dyComment', meta: {title: '评语管理'}, component: resolve => { require(['../components/paramset/DyComment.vue'], resolve) }},
              ]
            },
          ]
        },
      ]
    },
    {path: '/pcTip', meta: {title: 'pc端提示页'},component: resolve => { require(['@/components-other/PcTip.vue'], resolve) }},
    {path: '/system', meta: {title: '后台监控中心'},component: resolve => { require(['@/pages/system/Index.vue'], resolve) },
      children: [
        {path: '/', meta: {title: '首页'},component: resolve => { require(['@/pages/system/Main.vue'], resolve) }},
        {path: 'home', meta: {title: '应用中心'},component: resolve => { require(['@/pages/system/Home.vue'], resolve) }},
        {path: 'homeTransfer', meta: {title: '应用中心-导航'},component: resolve => { require(['@/pages/system/HomeTransfer.vue'], resolve) },
          children: [
            {path: 'tDingCorpInfoManager',meta: {title: '管理学校'},component: resolve => { require(['@/components-manager/TDingCorpInfoManager.vue'], resolve) }},
            {path: 'sysLogs',meta: {title: '系统日志'},component: resolve => { require(['@/components-manager/log/SysLog.vue'], resolve) }},
            {path: 'baseSetTab',meta: {title: '学校信息'},component: resolve => { require(['@/components-manager/baseset/BaseSetTab.vue'], resolve) },
              children: [
                {path: 'tDingCorpInfo',meta: {title: '基本信息'},component: resolve => { require(['@/components-manager/baseset/TDingCorpInfo.vue'], resolve) }},
                {path: 'tDingDeptUser',meta: {title: '通讯录'},component: resolve => { require(['@/components-manager/baseset/TDingDeptUser.vue'], resolve) }},
                {path: 'sysUsersManager',meta: {title: '账号管理'},component: resolve => { require(['@/components-manager/baseset/sysUsersManager.vue'], resolve) }},
                {path: 'sysUsersForm',meta: {title: '账号基本信息'},component: resolve => { require(['@/components-manager/baseset/sysUsersForm.vue'], resolve) }},
                {path: 'sysUsersSuccess',meta: {title: '账号创建成功'},component: resolve => { require(['@/components-manager/baseset/sysUsersSuccess.vue'], resolve) }},
                {path: 'sysUsersRelation',meta: {title: '关联钉钉用户'},component: resolve => { require(['@/components-manager/baseset/SysUsersRelation.vue'], resolve) }},
              ]
            },
          ]
        }
      ]
    },
    //其他
    ...other,
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js